import { AfterViewInit, Component, Input } from '@angular/core';
import { FirebaseService } from 'src/app/services/firebase.service';
import { Product } from '../../../interfaces'
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'myproducts-productitem',
  templateUrl: './productitem.component.html',
  styleUrls: ['./productitem.component.css']
})
export class MyProductItemComponent implements AfterViewInit {

  @Input('product')
  product: Product;

  auctionStatus: String = ""

  constructor(
    private _firebaseService: FirebaseService,
    private _userService: UserService,
    private _toastr: ToastrService,
    public router: Router,
  ) { }


  ngAfterViewInit(): void {

    if ('images' in this.product) {
      this.retrieveDownloadLink()
    }
  }

  retrieveDownloadLink() {

    if (this.product.images.length > 0) {
      this._firebaseService.getDownloadUrl(this.product.images[0]).subscribe(
        (data: any) => {
          this.product['image'] = data
          console.log(this.product);
        },

        (err) => {
          console.error(err);
        }
      )
    }
  }

  edit(pid: number){
    console.log(pid)
    this.router.navigate(['product', pid, 'edit']);
  }

  delete(pid: number){
    this._userService.deleteProduct(pid).subscribe(
      (data: any) => {
        this._toastr.success(data.msg);
      },

      (err: any) => {
        this._toastr.error(err.error.msg);
      }
    )
  }

}
